const registrationFlow = {
  stepProgress: "Step {step} of {total}",
  alreadyHaveAccount: "Already have an account? ",
  logIn: "Log in",
  otp: {
    title: "Verification",
    subtitle: "Verify your account & Enter the 4-digit code sent to your Email",
    otpLabel: "OTP code",
    digitAriaLabel: "Digit {n} of {total}",
    errors: {
      incomplete: "Please enter the complete 6-digit code.",
      incorrect: "The code you entered is incorrect. Please try again.",
    },
    actions: {
      previous: "Previous",
      createAccount: "Create Account",
    },
    didNotReceive: "Didn't receive the code?",
    resend: "Resend OTP",
    resendSuccessMessage: "Verification code sent to your email",
    maxAttemptsReached:
      "You've reached the maximum number of attempts. Please try again tomorrow.",
    afterTimer: "After ({time})",

  },
  pending: {
    statusHighlight: "pending",
    title: "Registration now\n{status} approval!",
    description:
      "Your registration request has been sent successfully! Please wait for {platformName} administrator reviews and accepts your enterprise registration request.",
    platformName: "Yoram",
    emailLabel: "Notification Email",
    emailNotProvided: "Not provided",
  },
};

export default registrationFlow;